import script from "./LinReg.vue?vue&type=script&lang=js"
export * from "./LinReg.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__